import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import AtividadeIntegradora from '../campos/atividadeIntegradora';
import ComoFoiIndiceFinal from '../campos/comoFoiIndiceFinal';
import FotosVideos from '../campos/fotosVideos';
import OQueMarcou from '../campos/oQueMarcou';
import Periodos from '../campos/periodos';
import PrincipiosValores from '../campos/principiosValores';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.indiceFinal;
export default function IndiceFinal() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({
      type: 'setEtapa',
      payload: etapa,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <ComoFoiIndiceFinal />
        <AtividadeIntegradora />
        <PrincipiosValores />
        <Periodos />
        <OQueMarcou />
        <FotosVideos etapa={etapa} />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
